import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const notaApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

notaApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('notaToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

notaApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('notaRefreshToken');
        if (refreshToken) {
          const response = await axios.post(`${BASE_URL}/api/nota/auth/refresh`, {
            refreshToken,
          });

          const { token } = response.data.data;
          localStorage.setItem('notaToken', token);

          originalRequest.headers.Authorization = `Bearer ${token}`;
          return notaApi(originalRequest);
        }
      } catch (refreshError) {
        localStorage.removeItem('notaToken');
        localStorage.removeItem('notaRefreshToken');
        localStorage.removeItem('notaUser');
        window.location.href = '/';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default notaApi;
